/**
 * Različica splošnih pogojev (datum objave). Ob vsaki vsebinski spremembi besedila ({@code BesediloPogojev}) jo
 * posodobite skupaj s {@code hera.registracija.verzija-pogojev} na strežniku (shrani se ob registraciji).
 */
export const RAZLICICA_POGOJEV = '2. 11. 2026';
